module.exports = __webpack_public_path__ + "static/media/5f75d81b-9d7e-4a32-b738-108dea41545a_1.d0817d0e63b08b439d8ac57281d24ade.53e1f765.jpeg";